<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M10.386 28c-.442 0-.865-.176-1.178-.488l-6.053-6.053a1.667 1.667 0 010-2.357L17.768 4.488c.65-.65 1.706-.65 2.357 0l8.72 8.721a1.666 1.666 0 010 2.357L18.413 26h7.255a1 1 0 110 2h-9.5a.963.963 0 01-.195-.019 1.67 1.67 0 01-.25.019h-5.335zm-1.34-11.96l-4.24 4.24 5.72 5.72h5.059l1.71-1.71-8.25-8.25zm16.734-.236l1.417-1.416-8.25-8.25-1.416 1.417 8.249 8.25z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsEraserOutline'
}
</script>
